import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';
import { LAWYER_TYPE_ADVOCATE } from '@/shared/constants/lawyerTypeConstants';
import type { ICity, ILawyerCardInfo } from '@/entities/lawyer/model/types/lawyer';

export const isLawyerCompany = (lawyer: ILawyerCardInfo): boolean =>
  Boolean(lawyer.company_id);

export const getLawyerFullName = (lawyer: ILawyerCardInfo): string =>
  `${lawyer.surname ?? ''} ${lawyer.name ?? ''} ${lawyer.middlename ?? ''}`
    .replace(/\s+/g, ' ')
    .trim();

export const getLawyerDisplayName = (lawyer: ILawyerCardInfo): string =>
  isLawyerCompany(lawyer) ? (lawyer.company?.name ?? '') : getLawyerFullName(lawyer);

export const getLawyerJobTitle = (lawyer: ILawyerCardInfo): string =>
  lawyer.role === LAWYER_TYPE_ADVOCATE ? 'Адвокат' : 'Юрист';

export const getLawyerCity = (lawyer: ILawyerCardInfo): ICity | undefined =>
  lawyer.addresses?.[0]?.city;

export const buildLawyerProfilePath = (lawyer: ILawyerCardInfo): string | null => {
  const citySlug = getLawyerCity(lawyer)?.slug;
  if (!citySlug || !lawyer.slug) return null;

  const type = isLawyerCompany(lawyer) ? 'organizations' : 'lawyers';
  return `${ROOT_CATALOG_URL}geo/${citySlug}/${type}/${lawyer.slug}/`;
};
